require('dom-slider');
const { slideToggle } = window.domSlider;
const textSidebar = () => {
	const blocks = document.querySelectorAll('.block-text-sidebar');
	const blockCount = blocks.length;
	if (blockCount >= 2) {
		const firstBlock = blocks[0];
		const lastBlock = blocks[blockCount - 1];

		firstBlock.querySelector('.back-to-top__wrapper').style.display =
			'none';
		blocks.forEach((block) => {
			if (block !== firstBlock) {
				block.querySelector('.share-icons').style.opacity = '0';

				const sidebarlinks = block.querySelectorAll(
					'.block-text-sidebar__sidebar-links'
				);
				if (sidebarlinks.length > 0) {
					sidebarlinks.forEach((section) => {
						section.style.display = 'none';
					});
				}
			}
			if (block !== lastBlock) {
				const disclaimer = block.querySelector(
					'.block-text-sidebar__disclaimer'
				);
				block.querySelector('.back-to-top__wrapper').style.display =
					'none';
				if (disclaimer) {
					disclaimer.style.display = 'none';
				}
			}
		});
	}
};
const toggleButton = document.querySelector(
	'.block-text-sidebar__show-more-button'
);
if (toggleButton) {
	toggleButton.addEventListener('click', (e) => {
		toggleCategories(e);
	});
}
const toggleCategories = (e) => {
	e.preventDefault();

	e.currentTarget.classList.toggle('active');

	if (e.currentTarget.classList.contains('active')) {
		e.currentTarget.innerHTML =
			e.currentTarget.getAttribute('data-text-open');
	} else {
		e.currentTarget.innerHTML =
			e.currentTarget.getAttribute('data-text-closed');
	}

	const hiddenContent = document.querySelector(
		'.block-text-sidebar__links-section--mobile-hidden'
	);

	slideToggle({
		element: hiddenContent,
		slideSpeed: 400,
		easing: 'ease-in-out',
	});
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		textSidebar();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
